/** @jsx jsx */
import { jsx, css } from '@emotion/core'
import React, { useState, useContext } from 'react'
import { Modal, Tabs, Spin, Input, message } from 'antd'
import FlexWrapMultiSelectPane from '../../../core/component/FlexWrapMultiSelectPane'
import { ErrorContext } from 'context'
// import ActionPane from '../admin/ActionPane'
// import { BaseDataContext } from '../context'

const roleToDisplay = role => role.displayName

const roleToId = role => role.role

const roleAcceptFilter = role => filterText =>
  role.displayName.toLowerCase().includes(filterText.toLowerCase())

const userToDisplay = user =>
  user.firstName != null || user.lastName != null
    ? `${user.firstName} ${user.lastName} (${user.userName})`
    : user.userName
const userToId = user => user.userName

const userAcceptFilter = user => filterText =>
  `${user.firstName} ${user.lastName} ${user.userName}`
    .toLowerCase()
    .includes(filterText.toLowerCase())

const RoleModal = ({
  hide,
  group = {},
  updateTask,
  createTask,
  isLoading,
  accessRoles = [],
  users = [],
}) => {
  const { setError } = useContext(ErrorContext)
  const processing = isLoading
  const { isNew = false } = group
  const [baseData, setBaseData] = useState(
    isNew ? { ...group, users: [], roles: [] } : group
  )

  const setSelectedRoles = setter =>
    setBaseData(r => ({ ...r, roles: setter(r.roles || []) }))
  const selectedRoles = baseData.roles || []

  const setSelectedUsers = setter =>
    setBaseData(r => ({ ...r, users: setter(r.users || []) }))
  const selectedUsers = baseData.users || []

  const onOk = () => {
    if (baseData.name === undefined || baseData.name.trim() === '') {
      message.error('Group Name must not be Empty')
    } else if (baseData.users.length === 0) {
      message.error('There must be one member in a Group')
    } else {
      if (isNew) {
        createTask([baseData]).fork(e => setError(e, _ => hide(null)), hide)
      } else {
        updateTask([baseData]).fork(e => setError(e, _ => hide(null)), hide)
      }
    }
  }
  return (
    <Modal
      title={isNew ? 'Create New Group' : `Update ${group.displayName}`}
      width="90vw"
      visible
      onOk={onOk}
      okText="Save"
      onCancel={hide}
      centered
      bodyStyle={{ minHeight: '50vh' }}
      maskClosable={false}
      okButtonProps={{ loading: processing }}
      cancelButtonProps={{ loading: processing }}
    >
      <Spin spinning={processing}>
        <div
          css={{
            display: 'flex',
            alignItems: 'center',
            paddingBottom: '32px',
            borderBottom: 'solid 1px #eee',
          }}
        >
          <label css={{ marginRight: '5px' }} htmlFor="title">
            Group Name:
          </label>
          <Input
            title="Group Name"
            css={{ flex: '1 0 100px', marginRight: '16px' }}
            placeholder="Group Name"
            maxLength={100}
            onChange={e => {
              e.persist()
              setBaseData(d => ({ ...d, name: e.target.value }))
            }}
            value={baseData.name}
          />
        </div>

        <Tabs defaultActiveKey="actions">
          <Tabs.TabPane key="members" tab="Members">
            <FlexWrapMultiSelectPane
              data={users}
              selectedIds={selectedUsers}
              setSelectedIds={setSelectedUsers}
              toDisplay={userToDisplay}
              toId={userToId}
              acceptFilter={userAcceptFilter}
              contentHeightOffset={450}
            />
          </Tabs.TabPane>
          <Tabs.TabPane key="roles" tab="Access Roles">
            <FlexWrapMultiSelectPane
              data={accessRoles}
              selectedIds={selectedRoles}
              setSelectedIds={setSelectedRoles}
              toDisplay={roleToDisplay}
              toId={roleToId}
              acceptFilter={roleAcceptFilter}
              contentHeightOffset={525}
            />
          </Tabs.TabPane>
        </Tabs>
      </Spin>
    </Modal>
  )
}

export default RoleModal
